import { get, post, downloadFile } from "../api_helper";

const getAllSubmittedForms = async () => {
  const url = "medical-forms/get-all-submitted-forms";
  const response = await get(url);
  return response;
};

const getSubmittedFormDetails = async (formId) => {
  const url = "medical-forms/get-submitted-form-details?formId=" + formId;
  const response = await get(url);
  return response;
};

const getMedicalFormForReview = async (chatId) => {
  const url = "medical-forms/get-medical-form-for-review?chatId=" + chatId;
  const response = await get(url);
  return response;
};

const updateMedicalForm = async (formData) => {
  const url = "medical-forms/update-medical-form";
  const response = await post(url, formData);
  return response;
};

const GetFacilityBookedAppointment = async () => {
  const url = "medical-forms/get-facility-booked-appointments";
  const response = await get(url);
  return response;
};

const GetFacilityBookedAppointmentDetails = async (formId) => {
  const url =
    "medical-forms/get-facility-booked-appointment-details?formId=" + formId;
  const response = await get(url);
  return response;
};

const getAllMobileRequests = async () => {
  const url = "medical-forms/get-all-mobile-requests";
  const response = await get(url);
  return response;
};

const getMobileRequestDetails = async (formId) => {
  const url = "medical-forms/get-mobile-request-details?formId=" + formId;
  const response = await get(url);
  return response;
};

const assignMobileLabToMobileRequest = async (data) => {
  const url = "medical-forms/assign-mobile-lab";
  const response = await post(url, data);
  return response;
};

const SubmitMedicalForm = async (payload) => {
  const url = "medical-forms/submit-medical-form";
  const response = await post(url, payload);
  return response;
};

const SubmitMedicalFormByAdmin = async (payload) => {
  const url = "medical-forms/submit-medical-form-by-admin";
  const response = await post(url, payload);
  return response;
};

export {
  getAllSubmittedForms,
  getSubmittedFormDetails,
  getMedicalFormForReview,
  updateMedicalForm,
  GetFacilityBookedAppointment,
  GetFacilityBookedAppointmentDetails,
  getAllMobileRequests,
  getMobileRequestDetails,
  assignMobileLabToMobileRequest,
  SubmitMedicalForm,
  SubmitMedicalFormByAdmin
};
